export interface SortOrderViewModel {
    id: string;
    sortOrder: number;
}
